/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

export interface LocalStorage {
  get: (name: string) => unknown
  getx: (name: string, maxLegacyTtlDays?: number) => unknown
  set: (name: string, value: unknown) => void
  setx: (name: string, value: unknown, expires?: number) => void
}

export const getTrackingTokens = (
  localStorageSingleton: Pick<LocalStorage, 'getx'>
): {
  P: unknown
  O: unknown
  V: unknown
  campaign: unknown
  template: unknown
  traffic: unknown
} => {
  return {
    P: localStorageSingleton.getx('_P'),
    O: localStorageSingleton.getx('_O'),
    V: localStorageSingleton.getx('_V'),
    campaign: localStorageSingleton.getx('_campaign'),
    template: localStorageSingleton.getx('_template'),
    traffic: localStorageSingleton.getx('_traffic'),
  }
}
